export enum BillingErrors {
      NO_USER_BUSINESS = "NO_USER_BUSINESS",
      NO_BUSINESS = "NO_BUSINESS",
      NO_BILLING = "NO_BILLING",
      TRIAL_EXPIRED = "TRIAL_EXPIRED",
      TRIAL_ACTIVE = "TRIAL_ACTIVE",
      ACTIVE = "ACTIVE",
      PAYMENT_FAILED = "PAYMENT_FAILED",
      PLAN_CANCELED = "PLAN_CANCELED",
}
